// 该文件用于创建Vuex中最核心的store
import Vue from "vue";
import Vuex from "vuex";
import storage from "../utils/storage";
Vue.use(Vuex);

// OPC 管理端的凭据统一用这两个键。
// 改动前这里 setToken/delToken 操作的是一个泛用的 "token" 键，而 OpcConsole 自己写的是
// opc_admin_token —— 同一份 token 在浏览器里存两份，getToken 还会回落到前者上。
const TOKEN_KEY = "opc_admin_token";
const USER_KEY = "opc_admin_user";

// 用vuex.Store对象来记录token
const store = new Vuex.Store({
  state: {
    token: "",
  },

  getters: {
    getToken(state) {
      return state.token || storage.get(TOKEN_KEY) || "";
    },
  },

  mutations: {
    // 修改token，并将token存入localstorage
    setToken(state, token) {
      state.token = token;
      storage.set(TOKEN_KEY, token);
    },
    // 集中清干净：request.js 的 401/403 与 OpcConsole 的退出都调它。
    // 只需要调这一处，调用方不必再各自 remove 一遍。
    delToken(state) {
      state.token = "";
      storage.remove(TOKEN_KEY);
      storage.remove(USER_KEY);
      // 顺手清掉旧版遗留的 "token" 键，免得它继续躺在老管理员的浏览器里
      storage.remove("token");
    },
  },

  actions: {},
});

export default store;
